<div class="titled-paragraph-container">
  <div class="content">
    <div class="headline">
      <kion-headline-tag
        [title]="component.title"
        [titleSize]="component.titleSize"
      ></kion-headline-tag>
    </div>
    <div class="content">
      <markdown [data]="component.content"></markdown>
    </div>
  </div>
</div>
